module.exports = __webpack_public_path__ + "static/media/general.8f85b4ab.png";